(() => {
/* Wild Gainz sticky add-to-cart bar.
   Progressive enhancement: the bar ships hidden (visibility hidden,
   translated off-screen, aria-hidden). Without this script it simply
   never appears. With it, the bar slides in once the visitor scrolls
   past the configured threshold and hides while any dialog is open. */

class WildgainzStickyCta extends HTMLElement {
  connectedCallback() {
    this.threshold = parseInt(this.dataset.scrollThreshold, 10) || 900;
    this.visible = false;
    this.pinned = false;

    this.onScroll = () => this.update();
    window.addEventListener('scroll', this.onScroll, { passive: true });

    // <dialog> elements fire no document-level event on open, so watch
    // the open attribute instead to keep the bar out from under modals.
    this.dialogObserver = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.target instanceof HTMLDialogElement) {
          this.update();
          return;
        }
      }
    });
    this.dialogObserver.observe(document.documentElement, {
      subtree: true,
      attributes: true,
      attributeFilter: ['open'],
    });

    if (window.Shopify && window.Shopify.designMode) {
      // Keep the bar on screen while it is selected in the theme editor
      // so the merchant can see edits without scrolling the preview.
      this.onSectionSelect = (event) => {
        if (!event.target.contains(this)) return;
        this.pinned = true;
        this.update();
      };
      this.onSectionDeselect = (event) => {
        if (!event.target.contains(this)) return;
        this.pinned = false;
        this.update();
      };
      document.addEventListener('shopify:section:select', this.onSectionSelect);
      document.addEventListener('shopify:section:deselect', this.onSectionDeselect);
    }

    this.update();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    if (this.dialogObserver) this.dialogObserver.disconnect();
    if (this.onSectionSelect) {
      document.removeEventListener('shopify:section:select', this.onSectionSelect);
      document.removeEventListener('shopify:section:deselect', this.onSectionDeselect);
    }
  }

  update() {
    const dialogOpen = document.querySelector('dialog[open]') !== null;
    const pastThreshold = window.scrollY > this.threshold;
    this.toggle((pastThreshold || this.pinned) && !dialogOpen);
  }

  toggle(show) {
    if (show === this.visible) return;
    this.visible = show;
    this.classList.toggle('is-visible', show);
    this.setAttribute('aria-hidden', show ? 'false' : 'true');
  }
}

if (!customElements.get('wildgainz-sticky-cta')) {
  customElements.define('wildgainz-sticky-cta', WildgainzStickyCta);
}
})();
